<div class="rm-header">
  <span>Subscribe</span>
</div>
<div class="row justify-content-center pt-4">
  <div class="col-11">
    <span style="font-size: medium;">
      <p>Please complete the information below to subscribe to this deal and allow Rondeivu to prepare your documents.</p>
      <p>
        <i>Note: By clicking Subscribe you are not making a binding commitment to invest. Completion of this form does not guarantee that your subscription will be accepted by the issuer.</i>
      </p>
    </span>
  </div>
</div>
<div class="row justify-content-center pt-3">
  <div class="col-11 text-center">
    <form>
      <mat-form-field class="form-field">
        <mat-label>Subscription Amount (Dollars)</mat-label>
        <input id="amt" name="amt" type="number" [min]="0" [(ngModel)]="data.indicationAmount" matInput
               placeholder="Enter amount in dollars USD" required>
      </mat-form-field>
      <mat-form-field class="form-field">
        <mat-label>Notes</mat-label>
        <textarea id="notes" name="notes" [(ngModel)]="data.notes" matInput placeholder="Please provide any additional notes regarding your subscription, such as contingencies or ongoing due diligence processes. These notes will be visible to Rondeivu and the Issuer."></textarea>
      </mat-form-field>
    </form>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-6">
    <button mat-raised-button mat-dialog-close>Cancel</button>
  </div>
  <div class="col-6 text-end">
    <button mat-raised-button color="primary" [mat-dialog-close]="data" [disabled]="!data.indicationAmount || data.indicationAmount < 0">SUBMIT</button>
  </div>
</div>
